var TurnTo =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["TurnToWpJsonp"];
/******/ 	window["TurnToWpJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/ 	var Promise;
/******/ 	if (typeof window['Promise'] === 'function' && /native code/.test(window['Promise']).toString()) {
/******/ 		Promise = window['Promise'];
/******/ 	} else {
/******/ 		Promise = function BootPromise(callback, handler) {
/******/ 		  var func = 'f'
/******/ 		  var obj = 'o'
/******/ 		  function is(type, item) { return (typeof item)[0] == type; }
/******/ 		  // Finalizes the promise by resolving/rejecting it with the transformed value
/******/ 		  function finalize(promise, resolve, reject, value, transform) {
/******/ 		    setImmediate(function () {
/******/ 		      try {
/******/ 		        // Transform the value through and check whether it's a promise
/******/ 		        value = transform(value);
/******/ 		        transform = value && (is(obj, value) | is(func, value)) && value.then;
/******/ 		        // Return the result if it's not a promise
/******/ 		        if (!is(func, transform))
/******/ 		          resolve(value);
/******/ 		        // If it's a promise, make sure it's not circular
/******/ 		        else if (value == promise)
/******/ 		          reject(TypeError());
/******/ 		        // Take over the promise's state
/******/ 		        else
/******/ 		          transform.call(value, resolve, reject);
/******/ 		      }
/******/ 		      catch (error) { reject(error); }
/******/ 		    });
/******/ 		  }
/******/
/******/ 		  // The `handler` variable points to the function that will
/******/ 		  // 1) handle a .then(resolved, rejected) call
/******/ 		  // 2) handle a resolve or reject call (if the first argument === `is`)
/******/ 		  // Before 2), `handler` holds a queue of callbacks.
/******/ 		  // After 2), `handler` is a finalized .then handler.
/******/ 		  handler = function pendingHandler(resolved, rejected, value, queue, then, i) {
/******/ 		    queue = pendingHandler.q;
/******/
/******/ 		    // Case 1) handle a .then(resolved, rejected) call
/******/ 		    if (resolved != is) {
/******/ 		      return Promise(function (resolve, reject) {
/******/ 		        queue.push({ p: this, r: resolve, j: reject, 1: resolved, 0: rejected });
/******/ 		      });
/******/ 		    }
/******/
/******/ 		    // Case 2) handle a resolve or reject call
/******/ 		    // (`resolved` === `is` acts as a sentinel)
/******/ 		    // The actual function signature is
/******/ 		    // .re[ject|solve](<is>, success, value)
/******/
/******/ 		    // Check if the value is a promise and try to obtain its `then` method
/******/ 		    if (value && (is(func, value) | is(obj, value))) {
/******/ 		      try { then = value.then; }
/******/ 		      catch (reason) { rejected = 0; value = reason; }
/******/ 		    }
/******/ 		    // If the value is a promise, take over its state
/******/ 		    if (is(func, then)) {
/******/ 		      try { then.call(value, transferState(1), rejected = transferState(0)); }
/******/ 		      catch (reason) { rejected(reason); }
/******/ 		    }
/******/ 		    // The value is not a promise; handle resolve/reject
/******/ 		    else {
/******/ 		      // Replace this handler with a finalized resolved/rejected handler
/******/ 		      handler = function (Resolved, Rejected) {
/******/ 		        // If the Resolved or Rejected parameter is not a function,
/******/ 		        // return the original promise (now stored in the `callback` variable)
/******/ 		        if (!is(func, (Resolved = rejected ? Resolved : Rejected)))
/******/ 		          return callback;
/******/ 		        // Otherwise, return a finalized promise, transforming the value with the function
/******/ 		        return Promise(function (resolve, reject) { finalize(this, resolve, reject, value, Resolved); });
/******/ 		      };
/******/ 		      // Resolve/reject pending callbacks
/******/ 		      i = 0;
/******/ 		      while (i < queue.length) {
/******/ 		        then = queue[i++];
/******/ 		        // If no callback, just resolve/reject the promise
/******/ 		        if (!is(func, resolved = then[rejected]))
/******/ 		          (rejected ? then.r : then.j)(value);
/******/ 		        // Otherwise, resolve/reject the promise with the result of the callback
/******/ 		        else
/******/ 		          finalize(then.p, then.r, then.j, value, resolved);
/******/ 		      }
/******/ 		    }
/******/ 		    // Returns a function that transfers the state of the promise
/******/ 		    function transferState(resolved) {
/******/ 		      return function (value) { then && (then = 0, pendingHandler(is, resolved, value)); };
/******/ 		    }
/******/ 		  };
/******/ 		  // The queue of pending callbacks; garbage-collected when handler is resolved/rejected
/******/ 		  handler.q = [];
/******/
/******/ 		  // Create and return the promise (reusing the callback variable)
/******/ 		  callback.call(callback = { then:    function (resolved, rejected) { return handler(resolved, rejected); },
/******/ 		                             "catch": function (rejected)           { return handler(0,        rejected); } },
/******/ 		                function (value)  { handler(is, 1,  value); },
/******/ 		                function (reason) { handler(is, 0, reason); });
/******/ 		  return callback;
/******/ 		}
/******/ 	}
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		23: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "Pk4jeZvHFwjKClIsite/js/" + ({"0":"expired-confirmation","1":"submission","2":"registration-modal","3":"media-modal","4":"profile","5":"cc-widget","6":"multi-item-search","7":"ask-results","8":"spectrum","9":"pdp-page","10":"comments-pinboard-page","11":"comments-pinboard-teaser-page","12":"order-confirmation-page","13":"base","14":"dfp","15":"review-form","16":"solo-question","17":"add-captions","18":"share-media","19":"add-video","20":"seller-ratings","21":"registration","22":"do-more"}[chunkId]||chunkId) + "." + {"0":"68932d0964e412ccfcb8","1":"6abd59627c873b0141e1","2":"e4e3ed19a9fd4438abea","3":"0c5eeccc00b4d4e6dfee","4":"830424cc65764e8e3a4d","5":"7d45ccce5e181d916442","6":"38a78d85f31774dc3ec3","7":"9e40687d966604c8597d","8":"59c8aa59e90b2744e999","9":"b5358c35bbe572ae7e78","10":"567f0013a3404f4d1829","11":"349a28f62e1eec49bd20","12":"b437e6608edc2475851f","13":"cbed63dac5e7d01edc31","14":"fa1ca3308c976287eb59","15":"3c14c791b9442a0e30ec","16":"c8a7efdf5b9f261deef1","17":"095ee89e80dab8d2c481","18":"3a64e5aa1f7b4a91edf5","19":"aade52508d242b4c7e97","20":"2ced0afacb3d429990dd","21":"6e0e1526f7ea999c9cb9","22":"f5d0472a3f70942e7190"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 156);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {/**@license MIT-promiscuous-©Ruben Verborgh*/
(function (func, obj) {
  // Type checking utility function
  function is(type, item) { return (typeof item)[0] == type; }

  // Creates a promise, calling callback(resolve, reject), ignoring other parameters.
  function Promise(callback, handler) {
    // The `handler` variable points to the function that will
    // 1) handle a .then(resolved, rejected) call
    // 2) handle a resolve or reject call (if the first argument === `is`)
    // Before 2), `handler` holds a queue of callbacks.
    // After 2), `handler` is a finalized .then handler.
    handler = function pendingHandler(resolved, rejected, value, queue, then, i) {
      queue = pendingHandler.q;

      // Case 1) handle a .then(resolved, rejected) call
      if (resolved != is) {
        return Promise(function (resolve, reject) {
          queue.push({ p: this, r: resolve, j: reject, 1: resolved, 0: rejected });
        });
      }

      // Case 2) handle a resolve or reject call
      // (`resolved` === `is` acts as a sentinel)
      // The actual function signature is
      // .re[ject|solve](<is>, success, value)

      // Check if the value is a promise and try to obtain its `then` method
      if (value && (is(func, value) | is(obj, value))) {
        try { then = value.then; }
        catch (reason) { rejected = 0; value = reason; }
      }
      // If the value is a promise, take over its state
      if (is(func, then)) {
        try { then.call(value, transferState(1), rejected = transferState(0)); }
        catch (reason) { rejected(reason); }
      }
      // The value is not a promise; handle resolve/reject
      else {
        // Replace this handler with a finalized resolved/rejected handler
        handler = function (Resolved, Rejected) {
          // If the Resolved or Rejected parameter is not a function,
          // return the original promise (now stored in the `callback` variable)
          if (!is(func, (Resolved = rejected ? Resolved : Rejected)))
            return callback;
          // Otherwise, return a finalized promise, transforming the value with the function
          return Promise(function (resolve, reject) { finalize(this, resolve, reject, value, Resolved); });
        };
        // Resolve/reject pending callbacks
        i = 0;
        while (i < queue.length) {
          then = queue[i++];
          // If no callback, just resolve/reject the promise
          if (!is(func, resolved = then[rejected]))
            (rejected ? then.r : then.j)(value);
          // Otherwise, resolve/reject the promise with the result of the callback
          else
            finalize(then.p, then.r, then.j, value, resolved);
        }
      }
      // Returns a function that transfers the state of the promise
      function transferState(resolved) {
        return function (value) { then && (then = 0, pendingHandler(is, resolved, value)); };
      }
    };
    // The queue of pending callbacks; garbage-collected when handler is resolved/rejected
    handler.q = [];

    // Create and return the promise (reusing the callback variable)
    callback.call(callback = { then:    function (resolved, rejected) { return handler(resolved, rejected); },
                               "catch": function (rejected)           { return handler(0,        rejected); } },
                  function (value)  { handler(is, 1,  value); },
                  function (reason) { handler(is, 0, reason); });
    return callback;
  }

  // Finalizes the promise by resolving/rejecting it with the transformed value
  function finalize(promise, resolve, reject, value, transform) {
    setImmediate(function () {
      try {
        // Transform the value through and check whether it's a promise
        value = transform(value);
        transform = value && (is(obj, value) | is(func, value)) && value.then;
        // Return the result if it's not a promise
        if (!is(func, transform))
          resolve(value);
        // If it's a promise, make sure it's not circular
        else if (value == promise)
          reject(TypeError());
        // Take over the promise's state
        else
          transform.call(value, resolve, reject);
      }
      catch (error) { reject(error); }
    });
  }

  // Export the main module
  module.exports = Promise;

  // Creates a resolved promise
  Promise.resolve = ResolvedPromise;
  function ResolvedPromise(value) { return Promise(function (resolve) { resolve(value); }); }

  // Creates a rejected promise
  Promise.reject = function (reason) { return Promise(function (resolve, reject) { reject(reason); }); };

  // Transforms an array of promises into a promise for an array
  Promise.all = function (promises) {
    return Promise(function (resolve, reject, count, values) {
      // Array of collected values
      values = [];
      // Resolve immediately if there are no promises
      count = promises.length || resolve(values);
      // Transform all elements (`map` is shorter than `forEach`)
      promises.map(function (promise, index) {
        ResolvedPromise(promise).then(
          // Store the value and resolve if it was the last
          function (value) {
            values[index] = value;
            --count || resolve(values);
          },
          // Reject if one element fails
          reject);
      });
    });
  };

  // Returns a promise that resolves or rejects as soon as one promise in the array does
  Promise.race = function (promises) {
    return Promise(function (resolve, reject) {
      // Register to all promises in the array
      promises.map(function (promise) {
        ResolvedPromise(promise).then(resolve, reject);
      });
    });
  };
})('f', 'o');

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99).setImmediate))

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setLogLevel;
/* harmony export (immutable) */ __webpack_exports__["c"] = setLogTrace;
var LOG_MESSAGE_PREFIX = 'TurnTo';
var LEVEL_VALUES = {
    off: 0,
    error: 1,
    warn: 2,
    info: 3,
    debug: 4
};
var logLevel =  false ? 'debug' : 'error';
var logTrace = false;
function setLogLevel(level) {
    if (LEVEL_VALUES[level] === undefined) {
        // tslint:disable-next-line:no-console
        console.error("Invalid log level, '" + level + "'");
        return;
    }
    logLevel = level;
}
function setLogTrace(trace) {
    logTrace = trace;
}
function log(level) {
    return function (msg, error) {
        if (LEVEL_VALUES[level] > LEVEL_VALUES[logLevel]) {
            return;
        }
        var message = LOG_MESSAGE_PREFIX + ": (" + level + ") " + msg;
        if (logTrace) {
            try {
                throw new Error();
            }
            catch (e) {
                console[level](message, error || '');
                console[level](e.stack.split('\n').slice(2).join('\n'));
            }
            return;
        }
        console[level](message, error || '');
    };
}
/* harmony default export */ __webpack_exports__["a"] = ({
    error: log('error'),
    warn: log('warn'),
    info: log('info'),
    debug: log('debug')
});


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77), __webpack_require__(151)))

/***/ }),

/***/ 151:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadPage", function() { return loadPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_init_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_resource_loader__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_logger__ = __webpack_require__(11);



// This sets the path to the server so webpack knows how to load other chunks
// (dynamically loaded modules)
// NOTE: imports cannot go above this line unless they are already part of turnto.js
var path =  false ? '' : 'v5/widgets/';
__webpack_require__.p = __WEBPACK_IMPORTED_MODULE_0_init_config__["a" /* hostsConfig */].protocol + "://" + __WEBPACK_IMPORTED_MODULE_0_init_config__["a" /* hostsConfig */].widgetsHost + "/" + path;
function loadPage(pagesConfig) {
    var pageFilesConfig = pagesConfig[__WEBPACK_IMPORTED_MODULE_0_init_config__["b" /* turnToConfig */].pageId];
    if (!pageFilesConfig) {
        __WEBPACK_IMPORTED_MODULE_2_util_logger__["a" /* default */].error("Could not find configuration for pageId: " + __WEBPACK_IMPORTED_MODULE_0_init_config__["b" /* turnToConfig */].pageId);
        return;
    }
    Object(__WEBPACK_IMPORTED_MODULE_1_init_resource_loader__["a" /* loadBaseCss */])(pageFilesConfig.baseCssFilePath);
    Object(__WEBPACK_IMPORTED_MODULE_1_init_resource_loader__["d" /* loadPageCss */])(pageFilesConfig.pageCssFilePath);
    Object(__WEBPACK_IMPORTED_MODULE_1_init_resource_loader__["b" /* loadBaseJs */])(pageFilesConfig.baseJsFilePath);
    if (!pageFilesConfig.pageJsFilePath[__WEBPACK_IMPORTED_MODULE_0_init_config__["b" /* turnToConfig */].locale]) {
        __WEBPACK_IMPORTED_MODULE_2_util_logger__["a" /* default */].error("Could not find a page configuration for locale: " + __WEBPACK_IMPORTED_MODULE_0_init_config__["b" /* turnToConfig */].locale);
        return;
    }
    Object(__WEBPACK_IMPORTED_MODULE_1_init_resource_loader__["e" /* loadPageJs */])(pageFilesConfig.pageJsFilePath[__WEBPACK_IMPORTED_MODULE_0_init_config__["b" /* turnToConfig */].locale]);
}
if (false) {
    // DO NOT REMOVE OR CHANGE THE loadPage LINE. The dev-pages-for-entry.js loader will replace that
    // with a pages object that is derived from the entry points listed in webpack.config.dev.js
    // loadPage({...})
}



/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* unused harmony export isWindows */
/* unused harmony export isIPhone */
/* unused harmony export isIPod */
/* unused harmony export isIPad */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isIOS; });
/* unused harmony export isGSA */
/* unused harmony export isIE */
/* unused harmony export isEdge */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isAndroid; });
/* unused harmony export hasPassiveEvents */
/* harmony export (immutable) */ __webpack_exports__["f"] = isMobileDevice;
/* harmony export (immutable) */ __webpack_exports__["a"] = breakpoint;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["b"] = dropCookie;
/* harmony export (immutable) */ __webpack_exports__["i"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["g"] = loadCss;
/* harmony export (immutable) */ __webpack_exports__["h"] = loadJs;
var uAgent = navigator.userAgent.toLowerCase();
function inAgent(str) {
    return uAgent.indexOf(str) !== -1;
}
var isWindows = inAgent('windows');
var isIPhone = !isWindows && inAgent('iphone');
var isIPod = inAgent('ipod');
var isIPad = inAgent('ipad');
var isIOS = isIPhone || isIPod || isIPad;
// Google Search App (for IOS)
var isGSA = inAgent('gsa') && isIOS;
var isIE = /msie|trident/.test(uAgent);
var isEdge = inAgent('edge/');
var isAndroid = inAgent('android');
var hasPassiveEvents = false;
if (typeof window !== 'undefined') {
    var passiveTestOptions = {
        get passive() {
            hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener('testPassive', null, passiveTestOptions);
    window.removeEventListener('testPassive', null, passiveTestOptions);
}
/**
 * Returns whether or not device is mobile for responsive:
 */
function isMobileDevice() {
    // ipads aren't mobile
    if (isIPad) {
        return false;
    }
    // smaller than 736 is mobile
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    if (screenWidth <= 736) {
        return true;
    }
    else if (screenWidth <= 1280 && Math.abs(window.orientation) === 90) {
        // Android landscape:
        return true;
    }
    else if (screenWidth === 1080 && screenHeight === 1920 && window.orientation === 0) {
        // Galaxy S4 portrait:
        return true;
    }
    else if (screenWidth === 1920 && screenHeight === 1080
        && Math.abs(window.orientation) === 90) {
        // Galaxy S4 landscape:
        return true;
    }
    return false;
}
/**
 * There are 4 breakpoints, 1-4, with 1 being smallest.
 * This returns which breakpoint applies for the current device.
 * NOTE: This will change with browser resize or orientation change.
 */
function breakpoint() {
    var viewport = window.innerWidth;
    // TODO: values are hard-coded until we have a way to load in the breakpoints.
    // Right now these are the same as what you will find in variables.scss
    if (viewport <= 569) {
        return 1;
    }
    else if (viewport <= 849) {
        return 2;
    }
    else if (viewport <= 1024) {
        return 3;
    }
    else if (viewport <= 1200) {
        return 4;
    }
    return 5;
}
// Get the value of the cookie with cName, return null if it does not exist
function getCookie(cName) {
    var value = null;
    var ac = document.cookie;
    var start = ac.indexOf(cName + "=");
    if (start >= 0) {
        start += cName.length + 1;
        var end = ac.indexOf(';', start);
        if (end === -1) {
            end = ac.length;
        }
        value = decodeURIComponent(ac.substring(start, end));
    }
    return value;
}
function dropCookie(cName) {
    setCookie(cName);
}
function setCookie(cName, value, age) {
    if (value === void 0) { value = undefined; }
    if (age === void 0) { age = undefined; }
    var dc = cName + "=";
    if (typeof value !== 'undefined') {
        dc += encodeURIComponent(value) + "; path=/";
        if (typeof age !== 'undefined') {
            if (age !== -1) {
                var d = new Date();
                d.setTime(d.getTime() + (age * 1000));
                dc += "; Expires=" + d.toUTCString();
            }
        }
    }
    else {
        // removes the cookie
        dc += "; path=/; Expires=" + new Date(0).toUTCString();
    }
    document.cookie = dc;
}
function loadCss(href, id) {
    var cssNode = document.getElementById(id);
    if (!cssNode) {
        var head = document.getElementsByTagName('head')[0];
        cssNode = document.createElement('link');
        cssNode.id = id;
        cssNode.type = 'text/css';
        cssNode.rel = 'stylesheet';
        cssNode.href = href;
        cssNode.media = 'screen';
        head.appendChild(cssNode);
    }
    else {
        cssNode.href = href;
    }
}
function loadJs(src, id, defer, async) {
    if (defer === void 0) { defer = true; }
    if (async === void 0) { async = false; }
    return new Promise(function (resolve, reject) {
        var jsNode = document.createElement('script');
        jsNode.id = id;
        jsNode.type = 'text/javascript';
        jsNode.src = src;
        // using defer instead of async to guarantee order
        jsNode.defer = defer;
        jsNode.async = async;
        jsNode.charset = 'utf-8'; // TT-12459
        jsNode.onload = function () { return resolve(true); };
        jsNode.onerror = function (e) { return reject(e); };
        var head = document.getElementsByTagName('head')[0];
        head.appendChild(jsNode);
    });
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),

/***/ 3:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return turnToConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hostsConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_store__ = __webpack_require__(4);

/**
 * Sets and exports the turnTo configuration options. Assumes that this is
 * called after the client sets `window.turnToConfig`.
 */
var fullTurnToConfig = window.turnToConfig || {};
var hostsConfig;
if (false) {
    hostsConfig = {
        protocol: fullTurnToConfig.protocol || 'http',
        cdnHost: fullTurnToConfig.cdnHost || 'localhost:9999',
        originHost: fullTurnToConfig.originHost || 'localhost:9999',
        widgetsHost: fullTurnToConfig.widgetsHost || 'localhost:9999',
        imageStoreBase: fullTurnToConfig.imageStoreBase || 'wac.edgecastcdn.net/001A39/qa/v5',
        moderationHost: fullTurnToConfig.moderationHost || 'dev.turntodev.com',
        siteKey: fullTurnToConfig.siteKey || 'DeaequNgimr7koRsite'
    };
}
else if (false) {
    hostsConfig = {
        protocol: fullTurnToConfig.protocol || 'https',
        cdnHost: fullTurnToConfig.cdnHost || 'qa-cdn-ws.turntodev.com',
        originHost: fullTurnToConfig.originHost || 'qa-ws.turntodev.com',
        widgetsHost: fullTurnToConfig.widgetsHost || 'qa-widgets.turntodev.com',
        imageStoreBase: fullTurnToConfig.imageStoreBase || 'wac.edgecastcdn.net/001A39/qa',
        moderationHost: fullTurnToConfig.moderationHost || 'qa.turntodev.com',
        siteKey: BUILD_SITE_KEY
    };
}
else if (true) {
    if (false) {
        hostsConfig = {
            protocol: 'https',
            cdnHost: 'staging-cdn-ws.turntodev.com',
            originHost: 'staging-ws.turntodev.com',
            widgetsHost: 'staging-widgets.turntodev.com',
            imageStoreBase: 'wac.edgecastcdn.net/001A39/staging',
            moderationHost: 'staging.turntodev.com',
            siteKey: BUILD_SITE_KEY
        };
    }
    else if (true) {
        hostsConfig = {
            protocol: 'https',
            cdnHost: 'cdn-ws.turnto.com',
            originHost: 'ws.turnto.com',
            widgetsHost: 'widgets.turnto.com',
            imageStoreBase: 'wac.edgecastcdn.net/001A39/prod',
            moderationHost: fullTurnToConfig.moderationHost || 'www.turnto.com',
            siteKey: "Pk4jeZvHFwjKClIsite"
        };
    }
    else if (process.env.region === 'eu1') {
        hostsConfig = {
            protocol: 'https',
            cdnHost: 'cdn-ws.turnto.eu',
            originHost: 'ws.turnto.eu',
            widgetsHost: 'widgets.turnto.eu',
            imageStoreBase: 'wac.edgecastcdn.net/005E122/eu1/prod',
            moderationHost: fullTurnToConfig.moderationHost || 'www.turnto.eu',
            siteKey: BUILD_SITE_KEY
        };
    }
}
/**
 * making sure locale is set for case where not specified
 */
if (!fullTurnToConfig.locale) {
    fullTurnToConfig.locale = "en_US" || 'en_US';
}
/**
 * Check for sku
 */
if (fullTurnToConfig.sku) {
    __WEBPACK_IMPORTED_MODULE_0__global_store__["a" /* default */].sku = fullTurnToConfig.sku;
}
// this narrows the scope of turnToConfig to exclude the hostsConfig. Doing this to a
// typescript error will happen if trying to access a hostsConfig property like siteKey
var turnToConfig = fullTurnToConfig;



/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_logger__ = __webpack_require__(11);
/**
 * Place to store global mutable state pertaining to TurnTo.
 * The `state` property within the store class contains the
 * actual data that changes, and there are setter/getters with
 * log statements to help in debugging.
 *
 * @see https://vuejs.org/v2/guide/state-management.html#Simple-State-Management-from-Scratch
 */

/**
 * The store class itself. An instance is created below and exported as
 * the default export.
 */
var Store = /** @class */ (function () {
    function Store() {
        this.state = {
            catItemId: null,
            parentCategoryIds: null,
            brand: null,
            loaders: [],
            sku: '',
            user: null
        };
        this.debug = true;
    }
    Object.defineProperty(Store.prototype, "catItemId", {
        get: function () {
            return this.state.catItemId;
        },
        set: function (catItemId) {
            __WEBPACK_IMPORTED_MODULE_0_util_logger__["a" /* default */].debug("globalStore.state.catItemId set with value \"" + catItemId + "\"");
            this.state.catItemId = catItemId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "parentCategoryIds", {
        get: function () {
            return this.state.parentCategoryIds;
        },
        set: function (parentCategoryIds) {
            __WEBPACK_IMPORTED_MODULE_0_util_logger__["a" /* default */].debug("globalStore.state.parentCategoryIds set with value \"" + parentCategoryIds + "\"");
            this.state.parentCategoryIds = parentCategoryIds;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "brand", {
        get: function () {
            return this.state.brand;
        },
        set: function (brand) {
            __WEBPACK_IMPORTED_MODULE_0_util_logger__["a" /* default */].debug("globalStore.state.brand set with value \"" + brand + "\"");
            this.state.brand = brand;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "loaders", {
        get: function () {
            return this.state.loaders;
        },
        set: function (loaders) {
            this.state.loaders = loaders;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "sku", {
        get: function () {
            return this.state.sku;
        },
        set: function (sku) {
            __WEBPACK_IMPORTED_MODULE_0_util_logger__["a" /* default */].debug("globalStore.state.sku set with value \"" + sku + "\"");
            if (typeof sku === 'number') {
                this.state.sku = sku.toString();
                return;
            }
            this.state.sku = sku;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "user", {
        get: function () {
            if (!this.state.user) {
                // returning empty user, makes it easier to not have to check for null
                // user before accessing a property
                return {
                    id: null,
                    isModerator: false,
                    firstName: '',
                    lastName: '',
                    nickName: ''
                };
            }
            return this.state.user;
        },
        // NOTE: this should only be called from token-service
        set: function (user) {
            this.state.user = user;
        },
        enumerable: true,
        configurable: true
    });
    return Store;
}());

/* harmony default export */ __webpack_exports__["a"] = (new Store());


/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = loadIcons;
/* harmony export (immutable) */ __webpack_exports__["a"] = loadBaseCss;
/* harmony export (immutable) */ __webpack_exports__["d"] = loadPageCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = loadBaseJs;
/* harmony export (immutable) */ __webpack_exports__["e"] = loadPageJs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_init_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_browser_utils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_ts_utils__ = __webpack_require__(7);



var BASE_CSS_ID = 'tt-base-css';
var BASE_JS_ID = 'tt-base-js';
var PAGE_CSS_ID = 'tt-page-css';
var PAGE_JS_ID = 'tt-page-js';
var SVG_CONTAINER_ID = 'tt-svg-icons';
var widgetsHostUrl = __WEBPACK_IMPORTED_MODULE_0_init_config__["a" /* hostsConfig */].protocol + "://" + __WEBPACK_IMPORTED_MODULE_0_init_config__["a" /* hostsConfig */].widgetsHost + "/v5/widgets";
if (false) {
    widgetsHostUrl = hostsConfig.protocol + "://" + hostsConfig.widgetsHost;
}
// The requireContext is passed in by the page entry file. It should be a context that points to
// the directory the svgs are located in. Example:
// loadIcons(require.context('assets/svg', true, /.svg$/))
function loadIcons(requireContext) {
    var symbols = requireContext.keys().reduce(function (accumulator, key) {
        return accumulator + requireContext(key);
    }, '');
    var div = document.createElement('div');
    div.id = SVG_CONTAINER_ID;
    div.style.display = 'none';
    div.style.width = '0';
    div.style.height = '0';
    Object(__WEBPACK_IMPORTED_MODULE_2_util_ts_utils__["h" /* waitForValue */])(function () { return document.body; }).then(function () {
        document.body.insertBefore(div, document.body.childNodes[0]);
        div.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
                symbols + '</svg>';
    });
}
function loadBaseCss(cssFilePath) {
    Object(__WEBPACK_IMPORTED_MODULE_1_util_browser_utils__["g" /* loadCss */])("" + widgetsHostUrl + cssFilePath, BASE_CSS_ID);
}
function loadPageCss(cssFilePath) {
    Object(__WEBPACK_IMPORTED_MODULE_1_util_browser_utils__["g" /* loadCss */])("" + widgetsHostUrl + cssFilePath, PAGE_CSS_ID);
}
function loadBaseJs(jsFilePath) {
    Object(__WEBPACK_IMPORTED_MODULE_1_util_browser_utils__["h" /* loadJs */])("" + widgetsHostUrl + jsFilePath, BASE_JS_ID);
}
function loadPageJs(jsFilePath) {
    Object(__WEBPACK_IMPORTED_MODULE_1_util_browser_utils__["h" /* loadJs */])("" + widgetsHostUrl + jsFilePath, PAGE_JS_ID);
}


/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* unused harmony export throttle */
/* harmony export (immutable) */ __webpack_exports__["d"] = debounce;
/* harmony export (immutable) */ __webpack_exports__["a"] = arrayFind;
/* harmony export (immutable) */ __webpack_exports__["b"] = arrayFindIndex;
/* harmony export (immutable) */ __webpack_exports__["e"] = getParameters;
/* harmony export (immutable) */ __webpack_exports__["f"] = mergeProps;
/* harmony export (immutable) */ __webpack_exports__["c"] = buildQryString;
/* harmony export (immutable) */ __webpack_exports__["g"] = openWindow;
/* harmony export (immutable) */ __webpack_exports__["h"] = waitForValue;
function throttle(func, wait, options) {
    if (options === void 0) { options = {}; }
    var otherArgs = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        otherArgs[_i - 3] = arguments[_i];
    }
    var context;
    var args;
    var result;
    var timeout = null;
    var previous = 0;
    function later() {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) {
            context = null;
            args = null;
        }
    }
    // need to use function instead of () =>, so we have the proper context of "this"
    return function main() {
        var now = Date.now();
        if (!previous && options.leading === false) {
            previous = now;
        }
        var remaining = wait - (now - previous);
        context = this;
        args = otherArgs;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) {
                context = null;
                args = null;
            }
        }
        else if (!timeout && options.trailing !== false) {
            timeout = window.setTimeout(later, remaining);
        }
        return result;
    };
}
function debounce(func, delay) {
    var inDebounce;
    // need to use function instead of () =>, so we have the proper context of "this"
    return function main() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        clearTimeout(inDebounce);
        inDebounce = setTimeout(function () { return func.apply(context, args); }, delay);
        return inDebounce;
    };
}
function arrayFind(arr, fn) {
    if (Array.prototype.find) {
        return arr.find(fn);
    }
    var index = arrayFindIndex(arr, fn);
    return index > -1 ? arr[index] : undefined;
}
function arrayFindIndex(arr, fn) {
    if (Array.prototype.findIndex) {
        return arr.findIndex(fn);
    }
    var list = Object(arr);
    // Makes sure always has an positive integer as length.
    var length = list.length >>> 0;
    for (var i = 0; i < length; i++) {
        var element = list[i];
        if (fn.call(undefined, element, i, list)) {
            return i;
        }
    }
    return -1;
}
var qryStrParams;
function getParameters() {
    if (qryStrParams) {
        return qryStrParams;
    }
    qryStrParams = {};
    if (window.location.search.indexOf('?') === 0) {
        var hashes = window.location.search.substring(1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            // can't just splite '=' because the value can contains '=' as well
            var name_1 = hashes[i].substring(0, hashes[i].indexOf('='));
            var value = hashes[i].substring(hashes[i].indexOf('=') + 1);
            qryStrParams[name_1] = decodeURIComponent(value);
        }
    }
    return qryStrParams;
}
// This function copies properties from the 2nd object onto the first object and
// returns it.  It will copy nested values as well.
// NOTE: this is a shallow copy.  Changing object values in one, will change the other.
function mergeProps(obj1, obj2) {
    Object.keys(obj2).forEach(function (k) {
        if (obj2[k] && typeof obj2[k] === 'object' && !Array.isArray(obj2[k])) {
            if (!obj1[k]) {
                obj1[k] = {};
            }
            mergeProps(obj1[k], obj2[k]);
        }
        else {
            obj1[k] = obj2[k];
        }
    });
    return obj1;
}
/**
 *  Builds a query string with the given params object.
 *  Query string output does not have beginning ?.
 *  Example: 'param1=val1&param2=value2&param3=value3'
 */
function buildQryString(params) {
    return Object.keys(params)
        .map(function (p) { return p + "=" + encodeURIComponent(params[p]); })
        .join('&');
}
function openWindow(url, name, width, height) {
    if (name === void 0) { name = ''; }
    if (width === void 0) { width = 600; }
    if (height === void 0) { height = 400; }
    var top = (screen.height / 2) - 400;
    var left = (screen.width / 2) - 600;
    var windowDimensionsAndPosition = "width=600,height=400,top=" + top + ",left=" + left;
    window.open(url, name, "menubar=no,toolbar=no,resizable=yes,scrollbars=yes," + windowDimensionsAndPosition);
}
function waitForValue(func, attempt, maxAttempts) {
    if (attempt === void 0) { attempt = 1; }
    if (maxAttempts === void 0) { maxAttempts = 10; }
    return new Promise(function (resolve, reject) {
        var value = func();
        if (value) {
            resolve(value);
        }
        else if (attempt < maxAttempts) {
            window.requestAnimationFrame(function () {
                waitForValue(func, attempt + 1)
                    .then(function (v) { return resolve(v); }).catch(function () { return reject(); });
            });
        }
        else {
            reject();
        }
    });
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),

/***/ 77:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(150);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ })

/******/ });


// WEBPACK FOOTER //
// Pk4jeZvHFwjKClIsite/js/turnto.js